export default __webpack_public_path__ + "static/media/android.ea05791d.jpeg";